import styled from 'styled-components';

export const GenralDataContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  column-gap: 160px;
  row-gap: 10px;

  @media(max-width: ${({ theme }) => theme.breakpoints.tablet}){
    grid-template-columns: 1fr
  }
`;
